"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTaskHealthApplicable = void 0;
/** Health checks only apply to tasks that are live (in preview or submitted). */
const isTaskHealthApplicable = (status) => status === 'PREVIEW' || status === 'SUBMITTED';
exports.isTaskHealthApplicable = isTaskHealthApplicable;
//# sourceMappingURL=Health.js.map